import type { Feature } from './feature';
import { t } from 'src/i18n';

export const features: Feature[] = [
  {
    id: 'MINI',
    displayName: t('features.mini.displayName'),
    description: t('features.mini.description'),
    bundle: true,
    module: false,
    features: [
      'ISSUES',
      'RISK',
      'STAFFING',
      'DATA',
      'QUALITY',
      'CORE_CONTENT',
      'HSE_CONTENT',
      'MEETINGS',
      'PERFORMANCE_REVIEW',
    ],
    prices: {
      a: { none: 415, member: 290 },
      b: { none: 830, member: 580 },
      c: { none: 1620, member: 1130 },
      d: { none: 2620, member: 1830 },
    },
  },
  {
    id: 'BASIC',
    displayName: t('features.basic.displayName'),
    description: t('features.basic.description'),
    bundle: true,
    module: false,
    features: [
      'ISSUES',
      'RISK',
      'STAFFING',
      'DATA',
      'QUALITY',
      'CORE_CONTENT',
      'HSE_CONTENT',
      'MEETINGS',
      'PERFORMANCE_REVIEW',
      'ASSETS',
      'SUBSTANCES',
    ],
    prices: {
      a: { none: 470, member: 325 },
      b: { none: 935, member: 650 },
      c: { none: 1820, member: 1270 },
      d: { none: 2940, member: 2055 },
    },
  },
  {
    id: 'EXTRA',
    displayName: t('features.extra.displayName'),
    description: t('features.extra.description'),
    bundle: true,
    module: false,
    features: [
      'ISSUES',
      'RISK',
      'STAFFING',
      'DATA',
      'QUALITY',
      'CORE_CONTENT',
      'HSE_CONTENT',
      'MEETINGS',
      'PERFORMANCE_REVIEW',
      'ASSETS',
      'SUBSTANCES',
    ],
    prices: {
      a: { none: 1180, member: 1035 },
      b: { none: 2365, member: 2080 },
      c: { none: 4610, member: 4060 },
      d: { none: 7445, member: 6560 },
    },
  },
  {
    id: 'HSE',
    displayName: t('features.hse.displayName'),
    description: t('features.hse.description'),
    bundle: true,
    module: false,
    features: ['ISSUES', 'RISK', 'SUBSTANCES', 'MEETINGS', 'PERFORMANCE_REVIEW', 'HSE_CONTENT'],
    price: 45,
    organizationPrice: 375,
  },
  {
    id: 'HSE-BHT',
    displayName: t('features.hseBht.displayName'),
    description: t('features.hseBht.description'),
    bundle: true,
    module: false,
    features: ['ISSUES', 'RISK', 'SUBSTANCES', 'MEETINGS', 'PERFORMANCE_REVIEW', 'HSE_CONTENT'],
    price: 45,
    organizationPrice: 375,
  },
  {
    id: 'OHS',
    displayName: t('features.ohs.displayName'),
    description: t('features.ohs.description'),
    bundle: true,
    module: false,
    features: ['ISSUES', 'RISK', 'SUBSTANCES', 'MEETINGS', 'HSE_CONTENT', 'HEALTHCARE', 'PERFORMANCE_REVIEW'],
    price: 45,
    organizationPrice: 750,
  },
  {
    id: 'HSE_CONTENT',
    displayName: t('features.hseContent.displayName'),
    description: '',
    bundle: false,
    module: false,
    price: 0,
  },
  {
    id: 'CORE_CONTENT',
    displayName: t('features.coreContent.displayName'),
    description: '',
    bundle: false,
    module: false,
    price: 0,
  },
  {
    id: 'MEETINGS',
    displayName: t('features.meetings.displayName'),
    description: '',
    bundle: false,
    module: true,
    price: 20,
  },
  {
    id: 'PERFORMANCE_REVIEW',
    displayName: t('features.performanceReview.displayName'),
    description: t('features.performanceReview.description'),
    bundle: false,
    module: true,
    price: 20,
  },
  {
    id: 'ISSUES',
    displayName: t('features.issues.displayName'),
    description: '',
    bundle: false,
    module: true,
    price: 20,
  },
  {
    id: 'RISK',
    displayName: t('features.risk.displayName'),
    description: '',
    bundle: false,
    module: true,
    organizationPrice: 40,
  },
  {
    id: 'STAFFING',
    displayName: t('features.staffing.displayName'),
    description: '',
    bundle: false,
    module: true,
    price: 40,
  },
  {
    id: 'ASSETS',
    displayName: t('features.assets.displayName'),
    description: '',
    bundle: false,
    module: true,
    price: 20,
  },
  {
    id: 'SUBSTANCES',
    displayName: t('features.substances.displayName'),
    description: '',
    bundle: false,
    module: true,
    price: 20,
  },
  {
    id: 'DATA',
    displayName: t('features.data.displayName'),
    description: '',
    bundle: false,
    module: true,
    price: 60,
  },
  {
    id: 'QUALITY',
    displayName: t('features.quality.displayName'),
    description: '',
    bundle: false,
    module: false,
    price: 0,
  },
  {
    id: 'EXTERNAL_CALENDAR',
    displayName: t('features.externalCalendar.displayName'),
    description: t('features.externalCalendar.description'),
    bundle: false,
    module: false,
    price: 0,
  },
  {
    id: 'HEALTHCARE',
    displayName: t('features.healthcare.displayName'),
    description: t('features.healthcare.description'),
    bundle: false,
    module: true,
    organizationPrice: 375,
  },
  {
    id: 'COLLECTIONS',
    displayName: t('features.collections.displayName'),
    description: '',
    bundle: false,
    module: false,
    price: 0,
  },
  {
    id: 'VIDEO',
    displayName: t('features.video.displayName'),
    description: '',
    bundle: false,
    module: false,
    price: 0,
  },
  {
    id: 'ASK',
    displayName: t('features.ask.displayName'),
    description: '',
    bundle: false,
    module: false,
    price: 0,
  },
  {
    id: 'NORENGROS-EXISTING',
    displayName: t('features.norengrosExisting.displayName'),
    description: t('features.norengrosExisting.description'),
    bundle: false,
    module: true,
    price: 0,
  },
  {
    id: 'NORENGROS-NEW',
    displayName: t('features.norengrosNew.displayName'),
    description: t('features.norengrosNew.description'),
    bundle: false,
    module: true,
    price: 0,
  },
  {
    id: 'SIGNAGE',
    displayName: t('features.signage.displayName'),
    description: t('features.signage.description'),
    bundle: false,
    module: false,
    // Infoskjerm er en egen modul, men skiller seg fra de andre: det er gratis
    // å opprette selve modulen – man betaler i stedet per skjerm man bestiller
    // (se SIGNAGE_SCREEN). Modulen har derfor ingen pris. orderOnly holder den
    // ute av den ordinære (betalte) modulvelgeren i innstillinger; opprettelse
    // skjer via modul-promoen ('signage').
    orderOnly: true,
    orderExplanation: t('features.signage.orderExplanation'),
  },
  {
    // Per-skjerm-bestilling (fysisk skjerm/mediespiller) – IKKE en modul, men en
    // bestilling med egen pris. Brukes kun for prisvisning i 'screen-order'-
    // promoen; legges aldri til som feature (d-screen-view dispatcher
    // place-screen-order, ikke add-features).
    id: 'SIGNAGE_SCREEN',
    displayName: t('features.signageScreen.displayName'),
    description: t('features.signageScreen.description'),
    bundle: false,
    module: false,
    orderOnly: true,
    startPrice: 1500,
    organizationPrice: 300,
  },
  {
    id: 'PRIVATE_NOTES',
    displayName: t('features.privateNotes.displayName'),
    description: t('features.privateNotes.description'),
    bundle: false,
    module: false,
    price: 0,
  },
  {
    id: 'NCC',
    displayName: 'NCC',
    description: t('features.ncc.description'),
    bundle: false,
    module: false,
    price: 0,
  },
  {
    id: 'MATRIX',
    displayName: t('features.matrix.displayName'),
    description: t('features.matrix.description'),
    bundle: false,
    module: false,
    price: 0,
  },
];
